/**
 * @generated SignedSource<<31b45c661e84f6d56fa9f3217a4a8d01>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type MarkTxnsInternalInputObject = {
  destinationBankAccountId?: string | null | undefined;
  destinationName?: string | null | undefined;
  txnIds: ReadonlyArray<string>;
};
export type needsReviewPage_MarkTxnsInternalMutation$variables = {
  input: MarkTxnsInternalInputObject;
};
export type needsReviewPage_MarkTxnsInternalMutation$data = {
  readonly markTxnsInternal: {
    readonly destination: {
      readonly id: string;
      readonly name: string;
      readonly nickname: string;
    } | null | undefined;
    readonly errors: ReadonlyArray<{
      readonly message: string;
    }>;
    readonly suggestion: {
      readonly additionalCount: number;
      readonly matchKind: string;
      readonly regex: string;
      readonly totalCount: number;
    } | null | undefined;
    readonly updatedCount: number;
  } | null | undefined;
};
export type needsReviewPage_MarkTxnsInternalMutation = {
  response: needsReviewPage_MarkTxnsInternalMutation$data;
  variables: needsReviewPage_MarkTxnsInternalMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updatedCount",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "BankAccount",
  "kind": "LinkedField",
  "name": "destination",
  "plural": false,
  "selections": [
    (v3/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "nickname",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "regex",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "matchKind",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "additionalCount",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "needsReviewPage_MarkTxnsInternalMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "MarkTxnsInternalMutationPayload",
        "kind": "LinkedField",
        "name": "markTxnsInternal",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "RuleSuggestion",
            "kind": "LinkedField",
            "name": "suggestion",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v9/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "needsReviewPage_MarkTxnsInternalMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "MarkTxnsInternalMutationPayload",
        "kind": "LinkedField",
        "name": "markTxnsInternal",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "RuleSuggestion",
            "kind": "LinkedField",
            "name": "suggestion",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v9/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "acaac1ba82143b81e919f58f7235e134",
    "id": null,
    "metadata": {},
    "name": "needsReviewPage_MarkTxnsInternalMutation",
    "operationKind": "mutation",
    "text": "mutation needsReviewPage_MarkTxnsInternalMutation(\n  $input: MarkTxnsInternalInputObject!\n) {\n  markTxnsInternal(input: $input) {\n    updatedCount\n    destination {\n      id\n      name\n      nickname\n    }\n    suggestion {\n      regex\n      matchKind\n      additionalCount\n      totalCount\n      id\n    }\n    errors {\n      message\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "c402e789cf4f5bb82d0f9260f2750476";

export default node;
